const navigationBlocks = document.querySelectorAll('.block-navigation');

if (navigationBlocks.length) {
	navigationBlocks.forEach((block) => {
		const socialButtonBlocks = block.querySelectorAll(
			'.block-navigation__menu > .is-style-social'
		);
		const searchButton = block.querySelector(
			'.block-navigation-search-button__button--mobile'
		);

		const featuredSingleLink = block.querySelector(
			'.block-navigation-columns__single-link'
		);

		const columnContent = block.querySelector(
			'.block-navigation-columns__content'
		);

		if (socialButtonBlocks.length > 0) {
			socialButtonBlocks.forEach((socialButtonBlock) => {
				const currentNavigationBlock = socialButtonBlock.closest(
					'.block-navigation__container'
				);

				if (currentNavigationBlock) {
					const mobileSocialButton =
						socialButtonBlock.cloneNode(true);

					mobileSocialButton.classList.add('wp-block-button--mobile');
					if (searchButton) {
						searchButton.parentNode.insertBefore(
							mobileSocialButton,
							searchButton.nextSibling
						);
					} else {
						currentNavigationBlock.appendChild(mobileSocialButton);
					}
				}
			});
		}

		const featuredLinkColumn = columnContent.querySelector(
			'.block-navigation-featured-link-column'
		);

		if (featuredSingleLink && columnContent) {
			const clonedFeaturedLink = featuredSingleLink.cloneNode(true);
			clonedFeaturedLink.classList.add(
				'block-navigation-columns__single-link--mobile'
			);
			if (featuredLinkColumn && columnContent) {
				columnContent.insertBefore(
					clonedFeaturedLink,
					featuredLinkColumn
				);
			} else {
				columnContent.appendChild(clonedFeaturedLink);
			}
		}
	});
}
